import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { formatDateTime } from "../../lib/format";
import { ShieldCheck } from "@phosphor-icons/react";

export default function AdminAudit() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setLogs(r.data)); }, []);

  return (
    <div className="space-y-8">
      <header>
        <div className="label-mono mb-2">Administración</div>
        <h1 className="font-display text-4xl font-black tracking-tighter flex items-center gap-3"><ShieldCheck size={36} weight="duotone" /> Auditoría</h1>
      </header>
      <div className="bento">
        <table className="w-full text-sm">
          <thead><tr className="label-mono border-b border-hairline">
            <th className="px-6 py-3 text-left">Fecha</th>
            <th className="px-6 py-3 text-left">Actor</th>
            <th className="px-6 py-3 text-left">Acción</th>
            <th className="px-6 py-3 text-left">Objetivo</th>
            <th className="px-6 py-3 text-left">Detalles</th>
          </tr></thead>
          <tbody>
            {logs.length === 0 && <tr><td colSpan="5" className="p-10 text-center text-inkMuted text-sm">Sin registros.</td></tr>}
            {logs.map((l) => (
              <tr key={l.id} className="border-b border-hairline">
                <td className="px-6 py-3 font-mono text-xs">{formatDateTime(l.created_at)}</td>
                <td className="px-6 py-3 font-mono text-xs">{l.actor_id?.slice(0, 8)}…</td>
                <td className="px-6 py-3 label-mono">{l.action}</td>
                <td className="px-6 py-3 font-mono text-xs">{l.target_id?.slice(0, 8)}…</td>
                <td className="px-6 py-3 text-xs text-inkMuted"><code>{JSON.stringify(l.details)}</code></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
